import {guid } from '../util/util'
import extendMethods from './extendMethods'
/**
 * @export BaseStore
 * @class BaseStore
 * @desc store 的基类，提供通用功能例如重设，方法统一访问接口，快照还原 等功能
 * @author lei.you
 * @date 2018/2/8
 * @update 2019/01/09 移除jquery
 * */
class BaseStore{
  /**
   * @desc 生成baseStore 实例
   * @param {object} config 配置文件
   * @return {BaseStore} baseStore 实例
   * */
  static getInstance(config){
    //debugger
    var baseStore=new BaseStore(config);
    baseStore.init();
    return baseStore;
  }
  /**
   * @desc 获取对应的store 实例的mapping
   * @param {string} guid
   * @return {BaseStore} baseStore 实例
   * */
  static getStateMapping(guid){
    return BaseStore.mapping[guid];
  }
  /**
   * @constructor
   * @param {object} config 配置
   * */
  constructor(config){
    this.guid=guid.getGuid();
    // 通过创建每个对象的的过程中在state 中添加一个关键唯一属性symbol ， 后续 是执行方法的时候在参数state中取出值来确定对应关系
    config.state[BaseStore.id]=this.guid;
    config.state.name=config.name;
    this.state=config.state;
    this.mutations=config.mutations;
    this.actions=config.actions;
    this.namespaced=config.namespaced||true;
    this.copyState={};
  }
  /**
   * @desc 初始化对象
   * */
  init(){
    BaseStore.mapping[this.guid]={}
    if(this.mutations){
      this.registerExtendMethods(this.mutations,extendMethods);
    }
    this.shoot(null,{key:BaseStore.STATE_INIT});
    //BaseStore.mapping[this.guid]=this.copyState;

  }
  /**
   * @description 注册baseStore中的扩展方法
   * @param {muntations} 被注册的muntations
   * @param {object} extendMethods
   *
   * */
  registerExtendMethods(muntations,extendMethods){
    for(var method in extendMethods){
      muntations[method]=extendMethods[method];
      this[method]=extendMethods[method];
    }

  }

}
BaseStore.STATE_INIT="STATE_INIT";
BaseStore.mapping={};
BaseStore.id= Symbol();
export default BaseStore;
